<template>
  <div class="content has-text-left">
    <div
      class="columns documents"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <div
        class="modal"
        :class="{'is-active': modals.POA.active}"
      >
        <div class="modal-background"></div>
        <div class="modal-content">
          <div
            class="box"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar', 'has-text-left': Language != 'fa' && Language != 'ar'}"
          >
            <h4>{{$t("please_select_country")}}</h4>

            <label
              class="label"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              for="country"
            >{{this.$t('country').tTitle()}}</label>
            <p class="control">
              <span class="select is-fullwidth">
                <select
                  v-validate="'required'"
                  :class="{'input': true, 'is-danger': errors.has('country') }"
                  :data-vv-as="this.$t('country').tTitle()"
                  name="country"
                  v-model="modals.POA.country"
                >
                  <option value></option>
                  <option
                    v-for="(item, index) in countries"
                    :value="index"
                    :key="index"
                  >{{item.name}}</option>
                </select>
              </span>
              <span
                v-show="errors.has('country')"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                class="help is-danger"
              >{{ errors.first('country') }}</span>
            </p>
            <br />
            <br />

            <div
              class="button is-success is-pulled-right"
              v-if="modals.POA.country !== ''"
              @click="setCountry()"
            >{{$t("set_country")}}</div>

            <footer class="modal-foot">
              <a
                class="button"
                @click="modals.POA.active = false, modals.POA.country = ''"
              >Close</a>
            </footer>
            <div class="is-clearfix"></div>
          </div>
        </div>
        <button class="modal-close is-large"></button>
      </div>

      <div class="column">
        <div class="card">
          <div class="card-image is-primary">
            <Dropzone
              v-if="documents.frontID === false"
              ref="myVueDropzone_1"
              id="myVueDropzone_1"
              class="dropzone"
              :useCustomSlot="true"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              @vdropzone-success="showSuccess"
              @vdropzone-sending="sending(...arguments, 'id-front', 'ple')"
            >
              <div class="dropzone-custom-content">
                <div class="subtitle">{{$t('drop_files_upload')}}</div>
              </div>
            </Dropzone>
            <div
              v-if="documents.frontID === 'approved'"
              class="status success"
            >
              <i class="fa fa-check"></i>
            </div>
            <div
              v-else-if="documents.frontID === 'pending'"
              class="status pending"
            >
              <div>
                <i class="fa fa-hourglass"></i>
                <p>{{$t('document_received')}}</p>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p
                  class="title is-4"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >
                  {{$t('proof_of_id_instructions').tUpper()}} /
                  <small>{{$t('front_of_id').tTitle()}}</small>
                </p>
              </div>
            </div>
            <div class="media">
              <div class="media-content attention">{{$t('passport_ple_different')}}</div>
            </div>
            <div class="content">
              <h4
                class="is-marginless is-danger"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
              <ul
                class="instructions"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <li>{{$t('cc_requirements_1')}}</li>
                <li>{{$t('document_req_color')}}</li>
                <li>{{$t('your_full_name')}}</li>
                <li>{{$t('a_unique_id_number')}}</li>
                <li>{{$t('your_birthdate')}}</li>
                <li>{{$t('your_place_of_birth')}}</li>
                <li>{{$t('a_visible_photo')}}</li>
                <li v-if="Language == 'th'">{{$t('your_signature')}}</li>
                <li>{{$t('your_nationality')}}</li>
                <li>{{$t('issue_date')}}</li>
                <li>{{$t('expiry_date')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-image">
            <Dropzone
              v-if="documents.backID === false"
              ref="myVueDropzone_2"
              id="myVueDropzone_2"
              class="dropzone"
              :useCustomSlot="true"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              @vdropzone-success="showSuccess"
              @vdropzone-sending="sending(...arguments, 'id-back', 'ple')"
            >
              <div class="dropzone-custom-content">
                <div class="subtitle">{{$t('drop_files_upload')}}</div>
              </div>
            </Dropzone>
            <div
              v-if="documents.backID === 'approved'"
              class="status success"
            >
              <i class="fa fa-check"></i>
            </div>
            <div
              v-else-if="documents.backID === 'pending'"
              class="status pending"
            >
              <div>
                <i class="fa fa-hourglass"></i>
                <p>{{$t('document_received')}}</p>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p
                  class="title is-4"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >
                  {{$t('proof_of_id_instructions').tUpper()}} /
                  <small>{{$t('back_of_id').tTitle()}}</small>
                </p>
              </div>
            </div>
            <div class="content">
              <h4
                class="is-marginless"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
              <ul
                class="instructions"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <li>{{$t('cc_requirements_1')}}</li>
                <li>{{$t('document_req_color')}}</li>
                <li>{{$t('your_full_name')}}</li>
                <li>{{$t('a_unique_id_number')}}</li>
                <li>{{$t('your_birthdate')}}</li>
                <li>{{$t('your_place_of_birth')}}</li>
                <li>{{$t('a_visible_photo')}}</li>
                <li v-if="Language == 'th'">{{$t('your_signature')}}</li>
                <li>{{$t('your_nationality')}}</li>
                <li>{{$t('issue_date')}}</li>
                <li>{{$t('expiry_date')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="columns documents"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <div class="column">
        <div class="card">
          <div class="card-image">
            <template v-if="userHasCountry">
              <Dropzone
                v-if="documents.residence === false"
                ref="myVueDropzone_3"
                id="myVueDropzone_3"
                class="dropzone"
                :useCustomSlot="true"
                :use-font-awesome="true"
                :options="dropzoneOptions"
                @vdropzone-success="showSuccess"
                @vdropzone-sending="sending(...arguments, 'address-proof', 'poa')"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">{{$t('drop_files_upload')}}</div>
                </div>
              </Dropzone>
              <div
                v-if="documents.residence === 'approved'"
                class="status success"
              >
                <i class="fa fa-check"></i>
              </div>
              <div
                v-else-if="documents.residence === 'pending'"
                class="status pending"
              >
                <div>
                  <i class="fa fa-hourglass"></i>
                  <p>{{$t('document_received')}}</p>
                </div>
              </div>
            </template>
            <template v-else>
              <a
                class="countrySelect"
                @click="modals.POA.active = true"
              >{{$t('please_select_your_country')}}</a>
            </template>
          </div>
          <div class="card-content">
            <div class="media">
              <div
                class="media-content"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <p class="title is-4">{{$t('proof_of_residence').tUpper()}}</p>
                <p class="subtitle is-6">{{$t('proof_of_residence_instructions').tTitle()}}</p>
              </div>
            </div>
            <div class="content">
              <h4
                class="is-marginless"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
              <ul
                class="instructions"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <li>{{$t('full_copy_of_the_document')}}</li>
                <li>{{$t('your_full_name')}}</li>
                <li>{{$t('your_physical_address')}}</li>
                <li>{{$t('recent_date')}}</li>
                <li>{{$t('must_be_a_utility_bill')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column"
        v-if="hasIslamicTA"
      >
        <div class="card">
          <div class="card-image">
            <Dropzone
              v-if="documents.islamic === false"
              ref="myVueDropzone_4"
              id="myVueDropzone_4"
              class="dropzone"
              :useCustomSlot="true"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              @vdropzone-success="showSuccess"
              @vdropzone-sending="sending(...arguments, 'islamic', 'por')"
            >
              <div class="dropzone-custom-content">
                <div class="subtitle">{{$t('drop_files_upload')}}</div>
              </div>
            </Dropzone>
            <div
              v-if="documents.islamic === 'approved'"
              class="status success"
            >
              <i class="fa fa-check"></i>
            </div>
            <div
              v-else-if="documents.islamic === 'pending'"
              class="status pending"
            >
              <div>
                <i class="fa fa-hourglass"></i>
                <p>{{$t('document_received')}}</p>
              </div>
            </div>
          </div>
          <div class="card-content">
            <div class="media">
              <div
                class="media-content"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <p class="title is-4">{{$t('islamic_account').tUpper()}}</p>
              </div>
            </div>
            <div class="content">
              <h4
                class="is-marginless"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
              <ul
                class="instructions"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <li>{{$t('islamic_documents_instructions')}}</li>
                <li>{{$t('full_copy_of_the_document')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="true/*canUseCC()*/">
      <h4 :class="{'has-text-right': Language == 'fa' || Language == 'ar'}">{{$t('upload_documents_note')}}</h4>
      <div
        class="columns documents"
        :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
      >
        <div class="column">
          <div class="card">
            <div class="card-image">
              <Dropzone
                v-if="documents.frontCC === false"
                ref="myVueDropzone_5"
                id="myVueDropzone_5"
                class="dropzone"
                :useCustomSlot="true"
                :use-font-awesome="true"
                :options="dropzoneOptions"
                @vdropzone-success="showSuccess"
                @vdropzone-sending="sending(...arguments, 'cc-front', 'cc')"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">{{$t('drop_files_upload')}}</div>
                </div>
              </Dropzone>
              <div
                v-if="documents.frontCC === 'approved'"
                class="status success"
              >
                <i class="fa fa-check"></i>
              </div>
              <div
                v-else-if="documents.frontCC === 'pending'"
                class="status pending"
              >
                <div>
                  <i class="fa fa-hourglass"></i>
                  <p>{{$t('document_received')}}</p>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div
                class="media-content"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <p class="title is-4">
                  {{$t('proof_of_cc').tUpper()}}
                  /
                  <small>{{$t('front_of_cc').tTitle()}}</small>
                </p>
                <p class="subtitle is-6">{{$t('proof_of_cc_instructions').tTitle()}}</p>
              </div>

              <div class="content">
                <h4
                  class="is-marginless"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
                <ul
                  class="instructions"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >
                  <li>{{$t('cc_requirements_1')}}</li>
                  <li>{{$t('cc_requirements_2')}}</li>
                  <li>{{$t('cc_requirements_3')}}</li>
                  <li>{{$t('cc_requirements_4')}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="card">
            <div class="card-image">
              <Dropzone
                v-if="documents.backCC === false"
                ref="myVueDropzone_6"
                id="myVueDropzone_6"
                class="dropzone"
                :useCustomSlot="true"
                :use-font-awesome="true"
                :options="dropzoneOptions"
                @vdropzone-success="showSuccess"
                @vdropzone-sending="sending(...arguments, 'cc-back', 'cc')"
              >
                <div class="dropzone-custom-content">
                  <div class="subtitle">{{$t('drop_files_upload')}}</div>
                </div>
              </Dropzone>
              <div
                v-if="documents.backCC === 'approved'"
                class="status success"
              >
                <i class="fa fa-check"></i>
              </div>
              <div
                v-else-if="documents.backCC === 'pending'"
                class="status pending"
              >
                <div>
                  <i class="fa fa-hourglass"></i>
                  <p>{{$t('document_received')}}</p>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div
                class="media-content"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <p class="title is-4">
                  {{$t('proof_of_cc').tUpper()}}
                  /
                  <small>{{$t('back_of_cc').tTitle()}}</small>
                </p>
                <p class="subtitle is-6">{{$t('proof_of_cc_instructions').tTitle()}}</p>
              </div>
              <div class="content">
                <h4
                  class="is-marginless"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
                <ul
                  class="instructions"
                  :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
                >
                  <li>{{$t('cc_requirements_1')}}</li>
                  <li>{{$t('cc_requirements_2')}}</li>
                  <li>{{$t('cc_requirements_3')}}</li>
                  <li>{{$t('cc_requirements_4')}}</li>
                  <li>{{$t('cc_back_requirements_5')}}</li>
                  <li>{{$t('cc_back_requirements_6')}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div
      v-for="rowGroup in otherArray"
      :key="'rowGroup-' + rowGroup"
      class="columns documents"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <div
        class="column"
        v-for="o in rowGroup"
        :key="o"
      >
        <div class="card">
          <div class="card-image">
            <Dropzone
              :id="'myVueDropzone_other' + o"
              ref="'myVueDropzone_other' + o"
              class="dropzone"
              :useCustomSlot="true"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              @vdropzone-success="showSuccess"
              @vdropzone-sending="sending(...arguments, 'other-' + o, 'other')"
            >
              <div class="dropzone-custom-content">
                <div class="subtitle">{{$t('drop_files_upload')}}</div>
              </div>
            </Dropzone>
          </div>
          <div class="card-content">
            <div class="media">
              <div
                class="media-content"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <p class="title is-4">{{$t('other').tUpper()}}</p>
                <p class="subtitle is-6">{{$t('other_documents_instructions').tTitle()}}</p>
              </div>
            </div>
            <div class="content">
              <h4
                class="is-marginless"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('documents_must_contain_all_of_the_following_details')}}</h4>
              <ul
                class="instructions"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >
                <li>{{$t('full_copy_of_the_document')}}</li>
                <li>{{$t('your_full_name')}}</li>
                <li>{{$t('your_residential_address')}}</li>
                <li>{{$t('date_of_issue')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column"
        v-if="rowGroup.length < columnsPerRow && totalOthers < maxOthers"
      >
        <div class="card add">
          <div
            class="card-image has-text-centered"
            @click="addOthers"
          >
            <div class="is-size-2">
              <i class="fa fa-plus"></i>
            </div>
            <div>{{$t('add_another_document')}}</div>
          </div>
          <div class="card-content">
            <div
              class="media-content"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >
              <p class="title is-4">{{$t('add_document').tUpper()}}</p>
              <p class="subtitle is-6">{{$t('click_to_add_another_document').tTitle()}}</p>
            </div>

            <div
              class="content"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >
              <p
                v-if="!isCorporate()"
                class="is-marginless"
              >{{$t('add_up_to_4_extra_documents')}}</p>
              <p
                v-else
                class="is-marginless"
                :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              >{{$t('add_up_to_10_extra_documents')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      class="email-note"
      :class="{'has-text-right direction-rtl': Language == 'fa' || Language == 'ar'}"
    >{{$t('for_further_info_attach')}}</p>
  </div>
</template>

<script>
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import Dropzone from 'vue2-dropzone'
import config from '../../config'
import api from '../../api'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    Dropzone,
  },
  data() {
    return {
      countries: config.countries,
      modals: {
        POA: {
          active: false,
          country: '',
        },
      },
      documents: {
        frontID: false,
        backID: false,
        frontCC: false,
        backCC: false,
        residence: false,
        other: false,
        islamic: false,
      },
      dropzoneOptions: {
        headers: {
          Authorization: this.$auth.token(),
        },
        url: '',
        uploadMultiple: false,
        maxFiles: 1,
        acceptedFiles: 'image/*,application/pdf',
        accept: function (file, done) {
          if (file.size === 0) {
            done('File is empty.')
          } else {
            done()
          }
        },
      },
      dzName: '',
      dzType: '',
      totalOthers: 0,
      maxOthers: 0,
      otherArray: [[]],
      columnsPerRow: 4,
    }
  },
  computed: {
    splitOthers() {
      let lists = []
      for (let i in this.totalOthers) {
        // let other = this.totalOthers[i]
        if (i % 5 === 0) {
          lists.push([])
        }
      }
    },
    userHasCountry() {
      return this.User.info.country_code !== ''
    },
    hasIslamicTA() {
      if (!this.User.TA.length) {
        return false
      }
      for (let i = 0; i < this.User.TA.length; i++) {
        if (this.User.TA[i].account_type_identifier === 'islamic') {
          return true
        }
      }
      return false
    },
    // getOtherRows() {
    //   console.log("rows is " + Math.floor(this.totalOthers / 4 + 1));
    //   return Math.floor(this.totalOthers / 4) + 1;
    // },
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
      Finance: 'finance/all',
    }),
  },
  created() {
    // get trading accounts (to check for islamic account)
    api.GetTradingAccounts()

    this.dropzoneOptions.url = config.API.host + 'documents/upload'
    // get uploaded documents
    this['logoLoader/set'](true)
    service
      .get('/documents/user/' + this.User.info.ID)
      .then(response => {
        if (response.data.Documents) {
          let docs = response.data.Documents
          for (let i = 0, l = docs.length; i < l; i++) {
            if (docs[i].document_status && docs[i].document_status !== 'rejected') {
              switch (docs[i].document_name) {
                case 'id-front':
                  this.documents.frontID = docs[i].document_status
                  break
                case 'id-back':
                  this.documents.backID = docs[i].document_status
                  break
                case 'cc-front':
                  this.documents.frontCC = docs[i].document_status
                  break
                case 'cc-back':
                  this.documents.backCC = docs[i].document_status
                  break
                case 'address-proof':
                  this.documents.residence = docs[i].document_status
                  break
                case 'other':
                  this.documents.other = true
                  break
                case 'islamic':
                  this.documents.islamic = true
                  break
              }
            }
          }
        }
        this['logoLoader/set'](false)
        this.maxOthers = this.getMaxOtherDocs()
      })
      .catch(() => {
        this['logoLoader/set'](false)
      })
  },
  mounted() {},
  methods: {
    addOthers() {
      this.totalOthers++
      this.otherArray[Math.floor((this.totalOthers - 1) / this.columnsPerRow)].push(this.totalOthers)
      if (this.totalOthers % this.columnsPerRow === 0 && this.totalOthers !== 0) {
        this.otherArray.push([])
      }
    },
    triggerUserReload() {
      // reload user by setting firstname to undefined
      let nu = Object.assign({}, this.User.info)
      delete nu.firstname
      this['user/setInfo'](nu)
    },
    setCountry() {
      if (this.modals.POA.country === '') {
        this.$toasted.error(this.$t('empty_country_code'))
      }
      if (this.modals.POA.country.length > 2) {
        this.$toasted.error(this.$t('invalid_country_code'))
      }

      service
        .post('/users/update-country', {
          userID: this.User.info.ID,
          countryCode: this.modals.POA.country,
        })
        .then(response => {
          if (response.data.success) {
            this.modals.POA.active = false
            // reload user
            this.triggerUserReload()
          }
        })
    },
    sending(file, xhr, formData, name, type) {
      formData.append('userID', this.User.info.ID)
      formData.append('documentName', name)
      formData.append('documentType', type)
    },
    showSuccess(file, response) {
      let jres = JSON.parse(response)
      if (typeof jres.message !== 'undefined') {
        let msg = JSON.parse(jres.message)
        if (typeof msg !== 'undefined') {
          switch (msg.documentName) {
            case 'id-front':
              this.documents.frontID = this.$t('client_state_pending')
              break
            case 'id-back':
              this.documents.backID = this.$t('client_state_pending')
              break
            case 'cc-front':
              this.documents.frontCC = this.$t('client_state_pending')
              break
            case 'cc-back':
              this.documents.backCC = this.$t('client_state_pending')
              break
            case 'address-proof':
              this.documents.residence = this.$t('client_state_pending')
              break
            case 'other':
              this.documents.other = true
              break
            case 'islamic':
              this.documents.islamic = this.$t('client_state_pending')
              break
          }
          api.GetDocumentCount()
        }
        // jsres.message.filename
      }
    },
    canUseCC() {
      let psp = this.Finance.PSPs['visa-mastercard']
      // console.log(psp);

      if (!this.User.wallet.currency) {
        return false
      }
      if (!psp.BlockedCurrencies && !psp.BlockedCountries) {
        return true
      }

      if (this.isCorporate()) {
        return false
      }

      let PSPCurrencyAllowed = !psp.BlockedCurrencies || !psp.BlockedCurrencies.length || psp.BlockedCurrencies.indexOf(this.User.wallet.currency.toUpperCase()) === -1
      let PSPCountryAllowed = !psp.BlockedCountries || !psp.BlockedCountries.length || psp.BlockedCountries.indexOf(this.User.info.country_code.toUpperCase()) === -1

      return PSPCurrencyAllowed && PSPCountryAllowed
    },
    isCorporate() {
      return this.$store.state.user.info.client.company_name !== undefined && this.$store.state.user.info.client.company_name !== ''
    },
    getMaxOtherDocs() {
      let maxOthers = 4

      if (this.isCorporate()) {
        maxOthers = 10
      }

      return maxOthers
    },
    ...mapActions(['logoLoader/set', 'user/setInfo']),
  },
}
</script>


<style lang="scss">
@import '../../assets/css/variables';
ul.instructions {
  clear: both;
  margin: 10px 20px 10px 10px;
  li {
    margin: 0 10px;
    font-size: 14px;
  }
}
.vue-dropzone.dropzone {
  background-color: #000;
}

.documents {
  .add {
    .card-image {
      cursor: pointer;
      padding: 2em 0;
      background: #000;
      transition: background 0.25s ease-in-out;

      &:hover {
        background: #fff;
      }
    }
  }

  .status {
    min-height: 156px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      display: flex;
      justify-content: center;
      color: #fff;
      font-size: 50px;
      margin-bottom: 10px;
    }
    p {
      color: #000;
    }

    &.success {
      background-color: #23d160;
    }
    &.pending {
      background-color: #fcba03;
    }
  }
}

.documents a.countrySelect {
  text-align: center;
  display: flex;
  height: 148px;
  background-color: #ff0000;
  color: #fff;
  justify-content: center;
  align-items: center;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// UploadDocuments.vue?5aecd7c4